import { getDailyRentOfferTypes } from './getDailyRentOfferTypes';
import { FDealType, FOfferType } from '../../../packages/JsonQuery';
import { IOfferTypeSelectOptionsGroup } from '../components/OfferTypeSelect';

export function normalizeOfferType(offerType: FOfferType): FOfferType {
  return (offerType & FOfferType.Residential) !== 0 ? FOfferType.Residential : FOfferType.Commercial;
}

const getOfferTypes = (
  isHotelsEnabled: boolean,
): {
  dealType: FDealType;
  offerType: FOfferType;
  list: IOfferTypeSelectOptionsGroup[];
}[] => [
  {
    dealType: FDealType.RentDaily,
    offerType: FOfferType.Residential,
    list: getDailyRentOfferTypes(isHotelsEnabled),
  },
];

export function getOfferTypeList(
  dealType: FDealType,
  offerType: FOfferType,
  isHotelsEnabled: boolean,
): IOfferTypeSelectOptionsGroup[] {
  const type = getOfferTypes(isHotelsEnabled).find(
    t => t.dealType === dealType && t.offerType === normalizeOfferType(offerType),
  );

  return type ? type.list : [];
}
